module.exports = __webpack_public_path__ + "img/logo.41e0418b.png";